"use client";

import { useState } from "react";
import { BackendInputWithLabel } from "@/app/components/backend";
import { ErrorMessage } from "../components/error-message";
import { SuccessMessage } from "../components/success-message";
import { AuthErrorContainer } from "../components/auth-error-container";
import { RequestPasswordButton } from "../components/request-password-button";
import { requestPassword } from "@/app/services/server/actions/auth/request-password";
import { LinkAnchor } from "@/app/components/ui/link-anchor";

export default function RequestPassword() {
  const [errors, setErrors] = useState<{
    emailError?: string;
    authError?: string;
    connectionError?: string;
  }>({});
  const [success, setSuccess] = useState<string | null>(null);

  const handleSubmit = async (formData: FormData) => {
    setErrors({});
    setSuccess(null);

    try {
      const result = await requestPassword(formData);

      if (result.success) {
        setSuccess(result.message || null);
      } else if (result.errors) {
        setErrors(result.errors);
      }
    } catch (error) {
      console.error("Fehler beim Formular-Submit:", error);

      // Prüfen, ob es sich um einen Netzwerkfehler handelt
      if (error instanceof Error) {
        if (
          error.message.includes("fetch failed") ||
          error.message.includes("network") ||
          error.message.includes("AuthRetryableFetchError")
        ) {
          setErrors({
            connectionError:
              "Keine Internetverbindung. Bitte überprüfen Sie Ihre Netzwerkverbindung und versuchen Sie es erneut.",
          });
        } else {
          setErrors({ authError: "Ein unerwarteter Fehler ist aufgetreten." });
        }
      } else {
        setErrors({ authError: "Ein unerwarteter Fehler ist aufgetreten." });
      }
    }
  };

  return (
    <div className="">
      <h1 className="backend-form-section-title text-[28px] font-semibold">
        Passwort vergessen
      </h1>
      <p className="mt-2 mb-6 text-sm text-[var(--c-muted)]">
        Gib deine E-Mail-Adresse ein um dein Passwort zurückzusetzen.
      </p>

      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <form action={handleSubmit}>
            <div className="flex flex-col gap-6">
              {/* Email */}
              <div className="relative">
                <BackendInputWithLabel
                  name="email"
                  label="E-Mail-Adresse"
                  aria-label="E-Mail-Adresse"
                  type="email"
                  id="email"
                  aria-invalid={!!errors.emailError}
                  className="h-12"
                />
                <ErrorMessage message={errors.emailError || ""} />
              </div>
            </div>

            {/* Success Message */}
            <SuccessMessage message={success} />

            {/* Connection Error */}
            {(errors.connectionError || errors.authError) && (
              <AuthErrorContainer
                error={errors.connectionError || errors.authError}
              />
            )}

            {/* Request button: reads the pending state from the form itself.
                State set inside the form action only renders once the action
                has finished, so it cannot drive the loading state. */}
            <RequestPasswordButton />
          </form>
          {/* Register link */}
          <div className="mt-2">
            <p className="text-center">
              <span className="mr-1.5 text-sm">Zurück zum</span>
              <LinkAnchor
                href="/login"
                className="text-[var(--c-accent)] hover:underline"
              >
                Login
              </LinkAnchor>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
